export default "__VITE_ASSET__aGAY27CK__"